module.exports = __webpack_public_path__ + "assets/Delete.91dada6ff53ab7303ac148d02f4e8095.svg";